<div class="container-fluid p-0">
  <div class="row form-group mb-3">
    <div class="col-md-12">
      <div class="row mb-2">
        <div class="col-md-4">
          <div class="text-left">
            <span class="">{{ 'pages.tables.spaces.name' | translate }}</span>
            <input [(ngModel)]="getSpace()!.name" class="form-control text-dark" id="name" [placeholder]="'pages.tables.spaces.name' | translate">
          </div>
        </div>
        <div class="col-md-8">
          <div class="text-left">
            <span class="">{{ 'pages.tables.spaces.description' | translate }}</span>
            <input [(ngModel)]="getSpace()!.description" class="form-control text-dark" id="description" [placeholder]="'pages.tables.spaces.description' | translate">
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6">
          <div class="text-left">
            <span class="">{{ 'pages.tables.spaces.line1' | translate }}</span>
            <input [(ngModel)]="getSpace()!.address!.line1" class="form-control text-dark" id="line1" [placeholder]="'pages.tables.spaces.line1' | translate">
          </div>
        </div>
        <div class="col-md-6">
          <div class="text-left">
            <span class="">{{ 'pages.tables.spaces.line2' | translate }}</span>
            <input [(ngModel)]="getSpace()!.address!.line2" class="form-control text-dark" id="line2" [placeholder]="'pages.tables.spaces.line2' | translate">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="text-left">
            <span class="">{{ 'pages.tables.spaces.city' | translate }}</span>
            <input [(ngModel)]="getSpace()!.address!.city" class="form-control text-dark" id="city" [placeholder]="'pages.tables.spaces.city' | translate">
          </div>
        </div>
        <div class="col-md-3">
          <div class="text-left">
            <span class="">{{ 'pages.tables.spaces.region' | translate }}</span>
            <input [(ngModel)]="getSpace()!.address!.region" class="form-control text-dark" id="region" [placeholder]="'pages.tables.spaces.region' | translate">
          </div>
        </div>
        <div class="col-md-3">
          <div class="text-left">
            <span class="">{{ 'pages.tables.spaces.zip' | translate }}</span>
            <input [(ngModel)]="getSpace()!.address!.zip" class="form-control text-dark" id="zip" [placeholder]="'pages.tables.spaces.zip' | translate">
          </div>
        </div>
        <div class="col-md-3">
          <div class="text-left">
            <span class="">{{ 'pages.tables.spaces.country' | translate }}</span>
            <input [(ngModel)]="getSpace()!.address!.country" class="form-control text-dark" id="country" [placeholder]="'pages.tables.spaces.country' | translate">
          </div>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-12 text-end">
          <button (click)="deleteSpace()" class="btn btn-outline-action-6 rounded-1 me-2" type="submit">{{'common.buttons.delete' | translate}}</button>
          <button (click)="saveSpace()" class="btn btn-action-2 rounded-1" type="submit">{{'common.buttons.save' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<admin-panel-standard [title]="'Users'" *ngIf="getUsers().length > 0; else noSelectedChannels">
  <admin-table-standard [items]="getUsers()">
    <ng-template #header>
      <th class="text-capitalize" style="width: 20%">{{ 'pages.tables.users.email' | translate }}</th>
      <th class="text-capitalize" style="width: 20%">{{ 'pages.tables.users.first_name' | translate }}</th>
      <th class="text-capitalize" style="width: 20%">{{ 'pages.tables.users.last_name' | translate }}</th>
      <th class="text-capitalize" style="width: 20%">{{ 'pages.tables.users.logins' | translate }}</th>
      <th class="text-capitalize" style="width: 10%">{{ 'pages.tables.users.status' | translate }}</th>
      <th style="width: 10%">&nbsp;</th>
    </ng-template>
    <ng-template #first let-item>
      <td>{{item.email}}</td>
      <td>{{item.firstName}}</td>
      <td>{{item.lastName}}</td>
      <td>{{item.login}}</td>
      <td [ngClass]="item.enabled ? 'text-success' : 'text-warning'">{{ item.enabled ? "enabled" : "disabled" }}</td>
      <td class="justify-content-around text-end ps-0 pe-0 weight-label">
        <a role="button" (click)="manageUser(item)" class="text-decoration-none text-purple action-buttons"><i class="bi bi-pencil-square" style="padding-left: 10px; padding-right: 10px;"></i>Manage</a>
      </td>
    </ng-template>
  </admin-table-standard>
</admin-panel-standard>

<ng-template #noSelectedChannels>
  <h5 class="border-top border-1 pt-3">No tenants found.</h5>
</ng-template>
